import { Box, Button, styled, TextField, Theme, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_HEADER_LINE,
  DARK_TEXT,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_HEADER_LINE,
  PASS_TEXT,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_TEXT,
} = COLORS;

export const MainCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  borderRadius: 8,
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const ResumeHeader = styled(Box)(({ theme }) => ({
  padding: 20,
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? DARK_HEADER_LINE : LIGHT_HEADER_LINE,

  width: '100%',
  display: 'flex',
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    padding: 10,
  },
}));

export const HRight = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
}));

export const HLeft = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('xs')]: {
    marginTop: 10,
  },
}));

export const TextsCont = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: 20,
  [theme.breakpoints.down('xs')]: {
    marginLeft: 10,
  },
}));

export const ResumeTitle = styled(Typography)(() => ({
  fontSize: 18,
  fontWeight: 600,
}));

export const Credits = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontSize: 15,
}));

export const CompletionCont = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: 300,
  flex: 1,
  marginLeft: 'auto',
}));

export const CompletionText = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 500,
  color: PASS_TEXT,
  marginRight: 14,
}));

export const AddCreditButton = styled(Button)(() => ({
  width: 134,
  height: 36,
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  borderRadius: 4,
  marginLeft: 20,
}));

export const ResumeContentCont = styled(Box)(() => ({}));
export const HiddenSection = styled(Box)(() => ({}));

export const HiddenHeader = styled(Box)(() => ({
  fontSize: 14,
  fontWeight: 500,
  margin: '0px 20px',
  borderBottom: `1px dashed ${DARK_FIELDS_ON_CARD_HEADER_LINE}`,

  paddingBottom: 10,
  marginBottom: 20,
}));

//Resume Item

export const ResumeItemCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  height: 54,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 16,
  flex: 1,
  userSelect: 'none',
}));

export const InfoCont = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  marginLeft: 14,
}));

export const ResumeItemName = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 500,
}));

export const ResumeItemCredit = styled(Box)(({ isActive, theme }: { isActive?: boolean; theme: Theme }) => ({
  fontSize: 15,
  fontWeight: 500,
  color: isActive ? PRIMARY_TEXT : theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  marginLeft: 14,
}));

export const ItemAddCreditButton = styled(Button)(() => ({
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  borderRadius: 4,
  width: 110,
  height: 30,
  backgroundColor: 'transparent',
}));

//Add Credit Modal

export const ModalCont = styled(Box)(({ theme }) => ({
  padding: 20,
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  height: 677,
  width: 628,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const ModalTitle = styled(Box)(() => ({
  fontSize: 24,
  fontWeight: 600,
  justifyContent: 'center',
  marginBottom: 49,
}));

export const AddCreditTextField = styled(TextField)(() => ({
  fontSize: 14,
}));

export const InputBinder = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '10px 40px',
  width: 426,
}));

export const Label = styled(Box)(() => ({
  fontSize: 13,
  color: PLAIN_TEXT,
  marginBottom: 10,
}));

export const ButtonCont = styled(Box)(() => ({
  display: 'flex',
  marginTop: 'auto',
  marginBottom: 10,
}));

export const CancelCreditModalButton = styled(Button)(() => ({
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  width: 206,
  height: 44,
  borderRadius: 5,
}));

export const AddCreditModalButton = styled(Button)(() => ({
  backgroundColor: PRIMARY_BUTTON_BACKGROUND,
  width: 206,
  height: 44,
  marginLeft: 15,
  borderRadius: 5,
}));

export const FetchingCont = styled(Box)(() => ({
  height: 100,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
